<template>
  <DetailViewContainer>
    <template #title>
      <h3 class="text-gray-900">
        Depot | {{ sparte }}
      </h3>
    </template>

    <template #header>
      <div class="flex items-center">
        <CompanyIcon :id="depot.company.id" />

        <div
          class="ml-2.5 text-sm text-muted"
          v-text="depot.company.name"
        />
      </div>
    </template>

    <template #main>
      <DepotDetailsTable
        :depot="depot"
        :contract="contract"
      />

      <DsAlert
        v-if="contract?.note"
        data-testid="depot-note-alert"
        type="primary"
        icon="circle-info"
        label="Maklerbemerkung"
        class="mt-5 whitespace-pre-line"
      >
        {{ contract.note }}
      </DsAlert>
    </template>

    <template #extra>
      <ShallowCardCollapsible
        :title="`Fonds (${depot.depotFonds?.length ?? 0})`"
        max-height="29rem"
        :disabled="!hasDepotFonds"
        :open="hasDepotFonds && !isMobile"
      >
        <DepotFonds :depot-fonds="depot.depotFonds!" />
      </ShallowCardCollapsible>
    </template>
  </DetailViewContainer>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import type { Depot } from '@/api/contracts/types';
import CompanyIcon from '@/application/components/CompanyIcon.vue';
import ShallowCardCollapsible from '@/application/components/ShallowCardCollapsible.vue';
import { useDetectMobile } from '@/application/composables/detectMobile';
import DepotFonds from '@/contracts/components/DepotFonds.vue';
import DetailViewContainer from '@/contracts/components/DetailViewContainer.vue';
import DepotDetailsTable from '@/contracts/components/DepotDetailsTable';
import { DsAlert } from '@demvsystems/design-components';
import { useContractStore } from '@/contracts/stores/contractStore.ts';

const props = defineProps<{ depot: Depot}>();

const { findContract } = useContractStore();
const { isMobile } = useDetectMobile();

const contract = computed(() => findContract(props.depot.id));
const sparte = computed(() => props.depot.product?.name.replace('->', ' › ') || '');
const hasDepotFonds = computed(() => props.depot.depotFonds && props.depot.depotFonds.length > 0);
</script>
